import { render } from "./AcceptTVA.vue?vue&type=template&id=336de1f1"
import script from "./AcceptTVA.vue?vue&type=script&lang=js"
export * from "./AcceptTVA.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../../DEV/_vue3/reactive-clinic/rc-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__